import { gql }  from '@apollo/client';

const MEMBERS_SEARCH = gql`
  query ($searchParams: MemberSearchParams!, $exactSearch: Boolean, $onlyPending: Boolean, $partialMatch: Boolean){
    membersSearch(searchParams: $searchParams, exactSearch: $exactSearch, onlyPending: $onlyPending, partialMatch: $partialMatch) {

      activeMembers {
        memberId
        userType
        firstName
        lastName
        dateOfBirth
        status
        primaryEmailAddress
        gender
        userName
        vipFlag
        lastMhdUpdate
        phoneNumbers {
          internationalFormattedNumber
        }
        person {
          securityQuestions {
            securityQuestion
            securityResponse
          }
        }
        mrns {
          mrnId
          isActive
          group {
            id
            name
            hasWebAccess
            serviceSpecialties {
              displayName
            }
            oneAppFlag
            registrationCode
          }
          isPrimary
          sourceMrnId
          sourceHealthPlanId
          coverageStartDate
          coverageEndDate
          serviceSpecialties {
            displayName
            conditionFlg
          }
        }

        residenceAddress {
          addressLine1
          addressLine2
          city
          zipcode
          state
        }
      }

      eligibilityMembers {
        mrnId
        mrnSourceClassificationCd
        benefitToken
        firstName
        lastName
        gender
        dateOfBirth
        primaryEmailAddress
        groupId
        coverageStartDate
        coverageEndDate
        groupRegistrationCode
        isActive
        isPrimary
        isRegistered
        sourceMrnId
        sourceHealthPlanId
        phoneNumbers {
          countryCode
          nationalNumber
          internationalFormattedNumber
        }
        addresses {
          city
          zipcode
          state
          addressLine1
          addressLine2
        }
        group {
          id
          name
          hasWebAccess
          oneAppFlag
        }
        serviceSpecialties(all: true) {
          displayName
        }
      }
      activeTotal
      eligibilityTotal
    }
  }
  `;

export default MEMBERS_SEARCH;
